// services/NotificationService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Compte connecté
export function getMyNotifications(params = {}) {
    return api.get(ENDPOINTS.NOTIFICATIONS.MINE, { params });
}
export function getUnreadCount() {
    return api.get(ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
}
export function markNotificationRead(id) {
    return api.post(ENDPOINTS.NOTIFICATIONS.MARK_READ(id));
}
export function markAllNotificationsRead() {
    return api.post(ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ);
}

// Administration (ADMIN/TEACHER)
export function getSentNotifications(params = {}) {
    return api.get(ENDPOINTS.NOTIFICATIONS.BASE, { params });
}
export function sendNotification(payload) {
    return api.post(ENDPOINTS.NOTIFICATIONS.BASE, payload);
}
export function deleteNotification(id) {
    return api.delete(ENDPOINTS.NOTIFICATIONS.BY_ID(id));
}
